import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setTemplateSorting} from 'store/slice/ManufSlice';

export default function TemplateListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.manufslice.templateDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setTemplateSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}

        <Grid item lg={2} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('title')}>&nbsp;</Typography></Grid> 
        <Grid item lg={2} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('title')}> Title</Typography></Grid>
        <Grid item lg={6} xs={4} sx={{pl:2}}><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('campaigntext')}> Campaign Text </Typography></Grid>

      </Grid>
      
    )
}